import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef, useState } from 'react';
import { useClickAway } from '@crehana/react-hooks';
var useContainerRef = function useContainerRef() {
  var containerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useClickAway(containerRef, function () {
    return setIsOpen(false);
  });
  return {
    containerRef: containerRef,
    isOpen: isOpen,
    setIsOpen: setIsOpen
  };
};
export default useContainerRef;